import Vue from 'vue2'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n'
import Formatter from '@/utils/formatter'
import Blue from '@blibli/dls'
import '@blibli/dls/dist/blue.min.css'

import '@blibli/dls/src/assets/scss/blue.scss'
import '@api-mock'
import TrackerMixins from '@/mixins/trackerMixins'

Vue.use(Formatter)
Vue.use(Blue)
Vue.mixin(TrackerMixins)

export default {
  start () {
    if (import.meta.env.MODE !== 'production') {
      Vue.config.devtools = true
    }
    new Vue({
      router,
      store,
      i18n,
      render: h => h(App)
    }).$mount('#app')
  }
}
